import { Form, Icon, Tooltip } from 'antd';
import React from 'react';
import { fieldNames } from '../../../common/config';
import DispexInput, {
  typeInput,
} from '../../../../../../../components/DispexInput';

const descriptionFieldName = fieldNames.description;
const FormItem = Form.Item;

const DescriptionField = ({ form }) => {
  return (
    <FormItem
      style={{ margin: 0 }}
      label={
        <span>
          Описание&nbsp;
          <Tooltip title="Описание показывается сотрудникам и собственникам в push-уведомлениях">
            <Icon
              type="info-circle"
              style={{ fontSize: '16px' }}
            />
          </Tooltip>
        </span>
      }
    >
      {form.getFieldDecorator(descriptionFieldName)(
        <DispexInput typeInput={typeInput.textarea} />
      )}
    </FormItem>
  );
};

export default DescriptionField;
